<template>
  <div>
    <div class="separator-breadcrumb border-top"></div>
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title mb-3">New commission</div>
            <fieldset class="border p-3">
              <div>
                <form @submit.prevent="newCommission()">
                  <div class="row">
                    <input
                      type="hidden"
                      class="truck_id"
                      :value="Trip.truck_id"
                    />
                    <input type="hidden" class="trip_id" :value="Trip.id" />
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Commission date</label>
                        <input
                          type="date"
                          class="form-control commission_date"
                          required
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <label>Truck name</label>
                      <input
                        type="text"
                        class="form-control"
                        :value="Trip.truck_no"
                        readonly
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="table-responsive" width="100">
                        <thead width="100%">
                          <tr>
                            <th scope="col">#</th>
                            <th scope="col">Description</th>
                            <th scope="col">Amount</th>
                            <th scope="col">Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(
                              commission_product, k
                            ) in commissionItemsrows"
                            :key="k"
                          >
                            <td scope="row">
                              <button
                                type="button"
                                class="btn btn-raised btn-raised-danger btn-sm m-1"
                                @click="deleteRow(k, commission_product)"
                              >
                                <i class="nav-icon i-Close-Window font-weight-bold"></i>
                              </button>
                            </td>
                            <td>
                              <input
                                type="text"
                                class="form-control"
                                v-model="commission_product.description"
                                required
                              />
                            </td>
                            <td>
                              <input
                                required
                                class="form-control text-right"
                                type="number"
                                min="1"
                                step="0.01"
                                v-model="commission_product.amount"
                                @wheel="$event.target.blur()"
                                @keyup="calculateLineTotal(commission_product)"
                              />
                            </td>
                            <td>
                              <input
                                required
                                class="form-control text-right"
                                type="number"
                                min="1"
                                step="0.01"
                                readonly
                                v-model="commission_product.total_price"
                              />
                            </td>
                          </tr>
                          <tr v-show="commissionItemsrows.length === 0">
                            <td colspan="7">
                              <p class="text-center alert-danger p-2">
                                No commissions added/available.
                              </p>
                            </td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <td colspan="3" class="text-right">Sub Total</td>
                            <input
                              readonly
                              class="form-control text-right sub_total"
                              type="number"
                              min="1"
                              step=".01"
                              :value="invoice_subtotal"
                            />
                          </tr>
                          <tr>
                            <td colspan="3" class="text-right">Total</td>
                            <input
                              readonly
                              class="form-control text-right grand_total"
                              type="number"
                              min="1"
                              step=".01"
                              :value="invoice_total"
                            />
                          </tr>
                        </tfoot>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                    <div class="col-md-12 mb-2">
                      <button
                        type="button"
                        class="btn btn-info addRow"
                        @click="addCommissionItems"
                      >
                        <i class="fa fa-plus-circle"></i>
                        Add
                      </button>
                    </div>
                    <button
                      type="submit"
                      class="btn btn-primary btn-flat creatingCommission btn-rounded"
                    >
                      <i class="fa fa-plus"></i> create commission
                    </button>
                    <button
                      type="button"
                      class="btn-rounded btn-flat creatingCommissionLoader btn-rounded"
                    >
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <i
                        class="fa fa-spinner fa-spin"
                        style="font-size: 24px"
                      ></i>
                      please wait...
                    </button>
                  </div>
                </form>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import router from "../router/index";
export default {
  data() {
    return {
      invoice_subtotal: 0,
      invoice_total: 0,
    };
  },
  created() {
    if (this.$store.getters.Trip.length === 0) {
      router.push("/managetrips");
    }
  },
  computed: {
    ...mapGetters(["systemCommissions", "Trip", "commissionItemsrows"]),
  },
  methods: {
    ...mapActions(["newCommission"]),
    ...mapMutations(["addCommissionItems"]),
    calculateTotal() {
      var subtotal, total, totals;
      subtotal = this.commissionItemsrows.reduce(function (sum, product) {
        var lineTotal = parseFloat(product.total_price);
        if (!isNaN(lineTotal)) {
          return sum + lineTotal;
        }
      }, 0);

      if (!isNaN(subtotal)) {
        this.invoice_subtotal = subtotal.toFixed(2);
      } else {
        this.invoice_subtotal = "0.00";
      }
      total = subtotal;
      total = parseFloat(total);
      if (!isNaN(total)) {
        this.invoice_total = total.toFixed(2);
      } else {
        this.invoice_total = "0.00";
      }
    },
    calculateLineTotal(commission_product) {
      var total = parseFloat(commission_product.amount) * 1;
      if (!isNaN(total)) {
        commission_product.total_price = total.toFixed(2);
      }
      // var inputTypeNumbers = document.querySelectorAll("input[type=number]");
      // for (var a = 0; a < inputTypeNumbers.length; a++) {
      //   inputTypeNumbers[a].onwheel = function (event) {
      //     event.target.blur();
      //   };
      // }
      this.calculateTotal();
    },
    deleteRow(idx, sale_product) {
      var idx = this.commissionItemsrows.indexOf(sale_product);
      if (idx > -1) {
        this.commissionItemsrows.splice(idx, 1);
      }
      this.calculateTotal();
    },
  },
};
</script>
<style scoped>
.creatingCommissionLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/commissions/commissions.vue